import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const TopUpLimitsPopup = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { isRegBank = false } = props;

    const { reachLimitText, increaseLimit, changeAmount, maxAmountPopupText, ...pageMessages } = usePageMessages();

    const {
        aml_ga_increase_level_link: linkToIncreaseLimitCase,
        maxAmount: { amount: leftAmount },
        topUpLimit = {},
        reachLimitText: extraReachLimitText,
    } = useExtra();

    const date = new Date(topUpLimit?.cycle_reset_date);
    const monthAndYear = !isRegBank
        ? resolveArguments(pageMessages[`month_${date.getMonth() + 1}_year`], date.getFullYear())
        : pageMessages['month_1_year'] + ' ' + date.getFullYear();
    const dateFormatted = date.getDate() + ' ' + monthAndYear;

    const getNotRegBankText = () => {
        const formattedMaxValue = getLocalizedRawAmount(lang, country, topUpLimit?.max_value);
        const formattedLeftAmount = getLocalizedRawAmount(lang, country, leftAmount);
        return !isRegBank
            ? resolveArguments(reachLimitText, [formattedMaxValue, formattedLeftAmount, dateFormatted])
            : resolveArguments(extraReachLimitText, [`${getLocalizedRawAmount(lang, country, leftAmount)} ${topUpLimit?.cur_iso}`, dateFormatted]);
    };

    const mainText = topUpLimit?.unlimited
        ? resolveArguments(maxAmountPopupText, [`${getLocalizedRawAmount(lang, country, leftAmount)} ${topUpLimit?.cur_iso}`])
        : getNotRegBankText();

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <SimplePopup text={getText(mainText)} popupRef={props.popupRef}>
            {!topUpLimit?.unlimited && <PopupButton href={linkToIncreaseLimitCase} target="_blank" iconName="arrow-up" text={increaseLimit} />}
            {!isRegBank && (
                <PopupButton
                    iconName="retry"
                    text={changeAmount}
                    onClick={(e) => {
                        e.preventDefault();
                        props.onProcessLinkClick(leftAmount);
                        props.popupRef.current?.close();
                    }}
                />
            )}
        </SimplePopup>
    );
};

TopUpLimitsPopup.propTypes = {
    isRegBank: PropTypes.bool,
};

export default TopUpLimitsPopup;
